import { defineStore } from "pinia";
import type { UserVo, User } from "@zhihaoscm/entity";
import { loginService } from "@/api/services/loginService";
import type { RouteRecordRaw } from "vue-router";

import mittManager from "../mittManager";

interface UserStore {
    userInfo: UserVo;
    token: string;
    banButton: boolean;
    menuList: RouteRecordRaw[];
    // TODO: 可能不需要了
    flatMenuList: RouteRecordRaw[];
}

export const useUserStore = defineStore("zhihao-user", {
    state: (): UserStore => {
        return {
            token: "",
            userInfo: {
                roles: [],
                user: {} as unknown as User,
                permissions: []
            },
            banButton: false,
            menuList: [],
            // TODO: 可能不需要了
            flatMenuList: []
        };
    },
    getters: {
        customerId({ userInfo }) {
            return userInfo.user?.id;
        }
    },
    actions: {
        setToken(token: string) {
            this.token = token;
        },
        setUserInfo(userInfo: UserVo) {
            this.userInfo = userInfo;
            this.banButton = userInfo.permissions.includes("ROLE_BUTTON_BAN");
        },
        /**
         * @description 设置菜单列表
         * @param menuList 菜单列表
         */
        setMenuList(menuList: RouteRecordRaw[]) {
            this.menuList = menuList;
        },
        /**
         * @description 设置扁平化菜单列表
         * @param flatMenuList 扁平化菜单列表
         */
        setFlatMenuList(flatMenuList: RouteRecordRaw[]) {
            this.flatMenuList = flatMenuList;
        },
        async refreshUserInfo() {
            const data: UserVo = await loginService.getUserInfo();
            this.setUserInfo(data);
            location.reload();
        }
    },
    persist: {
        storage: localStorage,
        async beforeHydrate(context) {
            // if (window.location.hostname === "localhost" || window.location.protocol === "http:") {
            // if (import.meta.env.DEV) {
            //     const localUser = await import("./localUser");
            //     Object.assign(context.store, localUser.default);
            //     localStorage.setItem("zhihao-user", JSON.stringify( localUser.default));
            // }
        },
        afterHydrate(context) {
            if (context.store.token) {
                // 初始化ws
                mittManager.emit("LOGIN:AFTER");

                window.parent?.postMessage({
                    type: 'LOGIN_SUCCESS',
                        token: context.store.token
                    },
                    '*'
                );
            }
        }
    }
});
